export default __webpack_public_path__ + "5f905452bfc3ec59304b1f0244430f4b.svg";